import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../../shared';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class OutputDetailsService {
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

  constructor(private http: HttpClient) { }
  generateRiskWarning(riskwarning) {
     if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get(this.endPoints.getRiskWarnings);
    } else {
      return this.http.post(this.endPoints.getRiskWarnings, riskwarning, { responseType: 'arraybuffer' });
    }

  }
}
